var app = angular.module("leonardo");

var DynamicFormToggleWarningDialog = function($scope) {
  $scope.submit = function() {
    $scope.confirm(true);
  };
};

app.controller('DynamicFormToggleWarningDialog', ['$scope', DynamicFormToggleWarningDialog]);
